// src/reduxStore/modules/drawer/selectors.js
import { createSelector } from '@reduxjs/toolkit';

// Default constants to prevent object creation on every selector call
const DEFAULT_DRAWER_STATE = {};
const DEFAULT_OPEN_POPUPS = {
  upgradePlan: false,
  rechargeAccount: false
};

// Base selector - simple function, no memoization needed
// Downstream selectors use createSelector for proper memoization
export const selectDrawerState = (state) => state.drawer || DEFAULT_DRAWER_STATE;

// Memoized selectors that depend on drawer state
export const selectOpenSupportDialog = createSelector(
  [selectDrawerState],
  (drawerState) => drawerState.openSupportDialog || false
);

export const selectPlanInfo = createSelector(
  [selectDrawerState],
  (drawerState) => drawerState.planInfo || null
);

export const selectSubscriptionInfo = createSelector(
  [selectDrawerState],
  (drawerState) => drawerState.subscriptionInfo || null
);

export const selectAccountUsage = createSelector(
  [selectDrawerState],
  (drawerState) => drawerState.accountUsage || null
);

// Note: billing is now in the billing slice (state.billing), use selectBillingState from billing/selectors

export const selectOpenPopups = createSelector(
  [selectDrawerState],
  (drawerState) => drawerState.openPopups || DEFAULT_OPEN_POPUPS
);

export const selectRefreshPlanInfoIndex = createSelector(
  [selectDrawerState],
  (drawerState) => drawerState.refreshPlanInfoIndex || 0
);